module.exports = __webpack_public_path__ + "img/cs-jiazhang_buy.9bc652b8.jpg";